(($) => {
  $(() => {
    const $header = $('.header');

    if ($header.length) {
      const observer = new IntersectionObserver(
        ([e]) => {
          e.target.classList.toggle('shadow-sm', e.intersectionRatio < 1);
        },
        {
          rootMargin: '-1px 0px 0px 0px',
          threshold: [1],
        }
      );

      observer.observe($header.get(0));
    }
  });
})(jQuery);
